<template>
  <div class="pc_container bind-workbench">
    <PageHeader type="5" :hasBack="false" :title="title"></PageHeader>
    <div class="bind-page">
      <div class="bind-panel">
        <div class="bind-notice bind-notice--bound" v-if="isBoundGoods">
          <i class="el-icon-warning-outline"></i>
          <!-- 该商品已绑定，请勿重复绑定商品 -->
          <span class="tip-text">{{
            $t('devUpdates.duplicateProductBindingNotAllowed')
          }}</span>
        </div>
        <div class="bind-notice bind-notice--login" v-else-if="!hasLogin">
          <i class="el-icon-warning-outline"></i>
          <!-- 请先 -->
          <!-- 登录 -->
          <!-- ，再绑定商品 -->
          <span class="tip-text"
            >{{ $t('devUpdates.pleaseFirstPrefix')
            }}<span class="login-link" @click="openLoginDialog">{{
              $t('common.login')
            }}</span
            >{{ $t('devUpdates.beforeLinkingTheProduct') }}</span
          >
        </div>

        <div class="bind-content">
          <div class="bind-goods-card" v-for="(item, idx) in list" :key="idx">
            <div class="bind-goods-card__body">
              <div class="product-section">
                <van-image
                  class="item-image"
                  :src="item.goodsImage || ''"
                  fit="cover"
                />
                <div class="product-content">
                  <div class="product-title-row">
                    <!-- 已绑定 -->
                    <!-- 待绑定 -->
                    <span
                      class="status-tag"
                      :class="
                        isBoundGoods ? 'status-tag--bound' : 'status-tag--ready'
                      "
                    >
                      {{
                        isBoundGoods
                          ? $t('devUpdates.linked')
                          : $t('devUpdates.notLinked')
                      }}
                    </span>
                    <div class="goods-name">{{ item.title }}</div>
                  </div>
                  <div class="product-meta">
                    <div class="info-row">
                      <!-- 发布时间： -->
                      <span class="label">{{
                        $t('devUpdates.published')
                      }}</span>
                      <span class="value">{{
                        $formatTime(item.createOn) || ""
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="spec-section">
                <div class="spec-item">
                  <!-- 料号 -->
                  <span class="summary-label">{{
                    $t('pcHome.partNumber')
                  }}</span>
                  <span class="summary-value spec-value">{{
                    item.goodsNum
                  }}</span>
                </div>
              </div>

              <div class="summary-section">
                <div class="summary-item">
                  <!-- 数量 -->
                  <span class="summary-label">{{
                    $t('mobile.home.quantity')
                  }}</span>
                  <span class="summary-value summary-quantity">{{
                    item.purchaseTotal
                  }}</span>
                  <span class="summary-unit">{{ item.goodsUnit }}</span>
                </div>
              </div>

              <div class="price-section">
                <div class="summary-item">
                  <!-- 价格 -->
                  <span class="summary-label">{{ $t('pcHome.price') }}</span>
                  <span class="summary-value summary-price">{{
                    item.purchasePrice || item.salePrice || ""
                  }}</span>
                  <span class="summary-unit">{{
                    getPriceUnitName(item.purchasePriceUnit || item.priceUnit)
                  }}</span>
                </div>
              </div>
            </div>

            <div class="bind-actions">
              <!-- 返回 -->
              <el-button class="action-link" @click="handleCancel">
                {{ $t('pcProduct.back') }}
              </el-button>
              <!-- 确认绑定 -->
              <el-button
                v-if="!isBoundGoods"
                class="action-primary"
                :disabled="!hasLogin || isBoundGoods || binding"
                :loading="binding"
                @click="handleConfirm"
              >
                {{ $t('devUpdates.confirmLinking') }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { MessageBox } from "element-ui";
import PageHeader from "@/components/pc/PageHeader.vue";
import { getMtsGoodsDetail } from "@/api/goods";
import { bindGoods } from "@/api/fastAccess";
import { getPriceUnitName } from "@/utils/vuexUnit";

export default {
  name: "bindGoods",
  data() {
    return {
      title: "绑定商品",
      // 商品数组（支持遍历）
      list: [],
      isBoundGoods: false, // 是否已绑定商品
      binding: false, // 是否正在提交绑定
    };
  },
  components: {
    PageHeader,
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userDetails,
      priceUnitTree: (state) => state.price.priceUnitTree,
      priceUnitCNY: (state) => state.price.priceUnitCNY,
      priceUnitUSD: (state) => state.price.priceUnitUSD,
    }),
    // 是否已登录
    hasLogin() {
      if (this.userInfo?.token) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    this.getGoodsDetail();
  },
  methods: {
    // 打开登录对话框
    openLoginDialog() {
      // 使用项目中现有的登录弹窗组件，而不是路由跳转
      this.$emit("openLoginDialog");
    },
    // 获取商品详情
    getGoodsDetail() {
      const goodsCode = this.$route.query.goodsCode || "";
      getMtsGoodsDetail(goodsCode).then((res) => {
        if (res.code === 200) {
          this.list = [{ ...res.data }];
          this.isBoundGoods = this.list[0].traderUserId !== 0;
          // isBoundGoods 不等于0就是已经被绑定，等于0就是未被绑定
        }
      });
    },
    // 获取价格单位名称
    getPriceUnitName(currentUnit) {
      const priceConfig = {
        usdUnit: this.priceUnitUSD,
        cnyUnit: this.priceUnitCNY,
      };
      return getPriceUnitName(currentUnit, priceConfig);
    },
    // 处理取消按钮点击事件
    handleCancel() {
      this.$router.replace({ path: "/pc/home" });
    },
    // 处理确认按钮点击事件
    async handleConfirm() {
      if (this.binding || this.isBoundGoods) return;
      if (this.userInfo?.authnStatus === 0) {
        this.showRealnameConfirm();
        return;
      }

      this.binding = true;
      try {
        const res = await bindGoods({ goodsId: this.list[0].goodsId });
        if (res.code === 200) {
          this.isBoundGoods = true;
          // 绑定商品成功!
          this.$message.success(this.$t("devUpdates.productLinkedSuccessfully"));
          setTimeout(() => {
            this.$router.replace({ path: "/pc/myxg/myGoods" });
          }, 1500);
        }
      } finally {
        this.binding = false;
      }
    },
    showRealnameConfirm() {
      const message = "《网络安全法》规定，实名才可发布信息，前往实名认证！";
      MessageBox.confirm(message, "温馨提示", {
        confirmButtonText: "前往实名认证",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.push({ path: "/pc/realname" });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped>
.bind-workbench {
  min-height: calc(100vh - 84px);
  background: #f6f7fb;
  overflow-x: hidden;
  box-sizing: border-box;
}

.bind-page {
  max-width: 1018px;
  margin: 0 auto;
  padding: 0 24px 80px;
  box-sizing: border-box;
}

.bind-panel {
  min-height: calc(100vh - 180px);
  padding: 14px;
  border: 1px solid #edf0f5;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.03);
  box-sizing: border-box;
}
.bind-notice {
  display: flex;
  align-items: center;
  margin: 16px 0 0;
  padding: 9px 12px;
  border: 1px solid #edf0f5;
  border-radius: 8px;
  background-color: #fff;
  color: #334155;
  font-size: 15px;
  line-height: 22px;

  .el-icon-warning-outline {
    margin-right: 10px;
    color: #4286f5;
    font-size: 20px;
  }
}

.bind-notice--bound .el-icon-warning-outline {
  color: #e45f5f;
}

.bind-content {
  min-height: 220px;
  padding: 20px 0 0;
}

.login-link {
  color: #4286f5 !important;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.bind-goods-card {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(128px, 152px);
  overflow: hidden;
  border: 1px solid #edf0f5;
  border-radius: 8px;
  background: #fff;
}

.bind-goods-card__body {
  display: grid;
  grid-template-columns:
    minmax(0, 1fr)
    minmax(104px, 128px)
    minmax(82px, 110px)
    minmax(100px, 140px);
  min-width: 0;
}

.product-section {
  display: flex;
  gap: 16px;
  min-width: 0;
  padding: 18px;
  box-sizing: border-box;
}

.item-image {
  width: 96px;
  height: 96px;
  flex: 0 0 96px;
  overflow: hidden;
  border: 1px solid #eef2f7;
  border-radius: 8px;
  background: #f8fafc;
}

::v-deep .item-image .van-image__img {
  border-radius: 8px;
}

.product-content {
  flex: 1;
  min-width: 0;
}

.product-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.status-tag {
  display: inline-block;
  flex: 0 0 auto;
  padding: 1px 7px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 17px;
  font-weight: 600;
  opacity: 0.9;
}

.status-tag--ready {
  color: #2f74e6;
  background: #f7fbff;
  border: 1px solid rgba(66, 134, 245, 0.24);
}

.status-tag--bound {
  color: #b84a4a;
  background: #fff7f7;
  border: 1px solid rgba(228, 95, 95, 0.22);
}

.goods-name {
  min-width: 0;
  color: #111827;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-meta {
  margin-top: 10px;
}

.info-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  font-size: 13px;
  line-height: 23px;
}

.label {
  color: #64748b;
}

.value {
  min-width: 0;
  color: #475569;
  font-weight: 500;
  overflow-wrap: anywhere;
}

.spec-section,
.summary-section,
.price-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 0;
  padding: 18px 12px;
  border-left: 1px solid #f0f2f5;
  text-align: center;
  box-sizing: border-box;
}

.spec-section {
  align-items: flex-start;
  padding: 18px 10px;
  text-align: left;
}

.spec-item {
  width: 100%;
}

.summary-item {
  display: flex;
  align-items: baseline;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6px;
  width: 100%;
  color: #64748b;
  font-size: 13px;
  line-height: 20px;
}

.summary-label {
  flex: 0 0 100%;
  color: #7b8794;
  font-size: 12px;
  line-height: 18px;
}

.summary-value {
  color: #1f2937;
  font-weight: 600;
}

.spec-value {
  display: block;
  width: 100%;
  margin-top: 2px;
  color: #64748b;
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  overflow-wrap: anywhere;
}

.summary-quantity {
  color: #4286f5;
  font-size: 20px;
  line-height: 26px;
}

.summary-price {
  color: #1f2937;
  font-size: 18px;
  line-height: 24px;
}

.summary-unit {
  color: #7b8794;
  font-size: 12px;
}

.bind-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 5px;
  min-width: 0;
  padding: 14px 10px;
  border-left: 1px solid #f0f2f5;
  background: #fff;
  box-sizing: border-box;
}

.bind-actions {
  /deep/ .el-button {
    width: auto;
    min-width: 0;
    max-width: 132px;
    margin: 0 !important;
    padding: 6px 12px !important;
    border-radius: 6px !important;
    border-color: #d9e2ef;
    background: #fff;
    color: #475569;
    font-size: 12px !important;
    line-height: 18px;
    font-weight: 500;
    white-space: nowrap;
    box-shadow: none;
  }

  /deep/ .el-button.action-link {
    height: 22px;
    padding: 0 3px !important;
    border-color: transparent !important;
    background: transparent !important;
    color: #6b7280 !important;
    font-weight: 400;
  }

  /deep/ .el-button.action-link:hover,
  /deep/ .el-button.action-link:focus {
    border-color: transparent !important;
    background: transparent !important;
    color: #4286f5 !important;
  }

  /deep/ .el-button.action-primary {
    min-width: 96px;
    height: 30px;
    padding: 0 12px !important;
    border-color: #5f91dc !important;
    background: #4f83d1 !important;
    color: #fff !important;
    font-size: 12px !important;
    font-weight: 500;
  }

  /deep/ .el-button.action-primary:hover,
  /deep/ .el-button.action-primary:focus {
    border-color: #3f74c5 !important;
    background: #3f74c5 !important;
    color: #fff !important;
  }

  /deep/ .el-button.is-disabled,
  /deep/ .el-button.is-disabled:hover,
  /deep/ .el-button.is-disabled:focus {
    border-color: #d9e2ef !important;
    background: #f8fafc !important;
    color: #94a3b8 !important;
  }
}

@media (max-width: 1180px) {
  .bind-goods-card,
  .bind-goods-card__body {
    grid-template-columns: 1fr;
  }

  .spec-section,
  .summary-section,
  .price-section,
  .bind-actions {
    border-left: none;
    border-top: 1px solid #f0f2f5;
  }

  .bind-actions {
    align-items: flex-end;
    flex-direction: row;
    justify-content: flex-end;
  }
}
</style>
